<template>
    <div class="modal fade" id="builder_modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content PageBreak">
                <div class="modal-header padding-x15 padding-y10">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-4 select-element-name">
                            <h6>Page Break</h6>
                            <div>
                                <input v-model="name" type="text" class="form-control">
                                <div class="invalid-feedback">Page Break or element with name {{ name }} already exists.</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer padding-y10">
                    <button :disabled="build_disabled" @click="buildElement" type="button" class="btn btn-success">{{ edit_mode ? 'Update' : 'Build' }} Element</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            this.element   = this.$store.getters.getBuilderPopupParams.element;
            this.edit_mode = this.$store.getters.getBuilderPopupParams.edit_mode || false;

            Object.assign(this.$data, vm.customClone(this.$store.getters.getBuilderPopupParams.data || {}));

            this.validate();
        },

        data() {
            return {
                name:           '',
                original_name:  '',
                element:        {},
                build_disabled: true,
                edit_mode:      false
            }
        },

        methods: {
            buildElement() {
                if (!this.edit_mode) {
                    this.$store.commit('addBuilderElement', {
                        name:                 this.name || this.$parent.generateElementName(),
                        element_id:           this.element.id,
                        element_abbreviation: this.element.abbreviation,
                        hide_element:         false
                    });
                } else {
                    this.$store.commit('updateBuilderElement', {
                        data: {
                            name:                 this.name || this.$parent.generateElementName(),
                            element_id:           this.element.id,
                            element_abbreviation: this.element.abbreviation,
                            hide_element:         this.element.hide_element
                        },

                        name: this.$store.getters.getBuilderPopupParams.data.original_name
                    });
                }

                event_bus.$emit('element_saved', true);

                $('#builder_modal').modal('hide');
            },

            changeConfig(configId, value) {
                if (typeof value === 'boolean') {
                    if (value === true) {
                        this.configurations[configId] = 'true';
                    } else {
                        delete this.configurations[configId];
                    }
                } else {
                    this.configurations[configId] = value;
                }

                this.$forceUpdate();
            },

            validate() {
                this.build_disabled = true;

                if (
                    this.name
                    && (
                        _.findIndex(this.$store.getters.getBuilderElements, {name: this.name}) === -1
                        || (this.edit_mode && this.$store.getters.getBuilderPopupParams.data.name === this.name)
                    )
                ) {
                    this.build_disabled = false;
                }
            }
        },

        watch: {
            name() {
                if (this.name) {
                    if (
                        _.findIndex(this.$store.getters.getBuilderElements, {name: this.name}) === -1
                        || (this.edit_mode && this.$store.getters.getBuilderPopupParams.data.name === this.name)
                    ) {
                        $('#builder_modal').find('.select-element-name input').removeClass('is-invalid');
                    } else {
                        $('#builder_modal').find('.select-element-name input').addClass('is-invalid');
                    }
                }

                this.validate();
            }
        }
    }
</script>
